import React, { useMemo, useRef } from "react";
import { Form } from "antd";
import { observer } from "mobx-react-lite";
import { MultiShopSelectPlatformType, MultiShopSelectPlatformTypeName } from "@/components/MultiShopSelect/types";
import WaybillTemplateSelect, { WaybillTemplateSelectProps } from "@/components/WaybillTemplateSelect2";
import WaybillPrinter from "@/services/print/waybill/WaybillPrinter";
import PrinterSelect from "@/components/PrinterSelect";
import { getRequiredRule } from "@/utils/formValidatorRules";
import TemplateSelectExtra from "../TemplateSelectExtra";
import MultiPlatformUseChildWaybillNoModeFormItem from "../MultiPlatformUseChildWaybillNoModeFormItem";
import { PlatformOrderInfo } from "..";
import ShopType from "@/enum/ShopType";
import "./index.less";

interface OtherDropShippingSupplierWaybillTemplateFormItemProps {
    defaultTemplateId?: number;
    platformOrderInfo: PlatformOrderInfo;
}

function getFilterableShopType(platform: MultiShopSelectPlatformType) {
    if (platform === MultiShopSelectPlatformType.other_drop_shipping_supplier_channel_shop) {
        return ShopType.CHANNEL_SHOP;
    }

    return undefined;
}

const OtherDropShippingSupplierWaybillTemplateFormItem: React.FC<
    OtherDropShippingSupplierWaybillTemplateFormItemProps
> = function (props) {
    const { defaultTemplateId, platformOrderInfo } = props;
    const showPrinterTipRef = useRef(true);

    const platforms = useMemo(
        () =>
            Object.keys(platformOrderInfo).filter((platform: MultiShopSelectPlatformType) => {
                return !!platformOrderInfo[platform]?.length;
            }) as MultiShopSelectPlatformType[],
        [platformOrderInfo],
    );

    const templateSelectProps: WaybillTemplateSelectProps = {
        style: {
            width: 280,
        },
        defaultTemplateId,
        onChange: (template) => {
            if (showPrinterTipRef.current) {
                if (template && !WaybillPrinter.isReady(template)) {
                    WaybillPrinter.openDownloadPluginDialog(template);
                    showPrinterTipRef.current = false;
                }
            }
        },
        popupMatchSelectWidth: false,
    };

    if (!platforms.length) return null;

    return (
        <Form.Item noStyle shouldUpdate>
            {(form) => {
                const values = form.getFieldsValue();
                const isGenerateWaybillNoOnly = values.isGenerateWaybillNoOnly;
                const printerSelectRules = !isGenerateWaybillNoOnly ? [getRequiredRule("打印机不能为空")] : null;

                return (
                    <div className="multi-platform-print-waybill-form-item-container">
                        <Form.Item label="其他代发快递单模板">
                            <div className="other-drop-shipping-supplier-template-container">
                                {platforms.map((platform) => {
                                    const template = values[platform]?.template;

                                    return (
                                        <Form.Item key={platform} colon={false} label=" ">
                                            <div style={{ display: "flex", width: "100%" }}>
                                                <Form.Item
                                                    className="out-order-form-item"
                                                    name={[platform, "template"]}
                                                    label={`${MultiShopSelectPlatformTypeName[platform]}模板`}
                                                    rules={[getRequiredRule("快递单模板不能为空")]}
                                                    extra={
                                                        <TemplateSelectExtra platform={platform} template={template} />
                                                    }
                                                >
                                                    <WaybillTemplateSelect
                                                        {...templateSelectProps}
                                                        hideRefresh
                                                        orderSourceCategory={platform}
                                                        filterableShopType={getFilterableShopType(platform)}
                                                    />
                                                </Form.Item>

                                                <Form.Item name={[platform, "printerName"]} rules={printerSelectRules}>
                                                    <PrinterSelect
                                                        style={{ width: 200 }}
                                                        className="ml10"
                                                        disabled={isGenerateWaybillNoOnly}
                                                        template={template}
                                                    />
                                                </Form.Item>
                                            </div>

                                            <MultiPlatformUseChildWaybillNoModeFormItem platform={platform} />
                                        </Form.Item>
                                    );
                                })}
                            </div>
                        </Form.Item>
                    </div>
                );
            }}
        </Form.Item>
    );
};

export default observer(OtherDropShippingSupplierWaybillTemplateFormItem);
